<template>
    <div>
        <div class="row">
            <div class="col-12">
                <form
                    class="border-secondary py-5 text-center rounder-8"
                    style="border-width: 2px; border-style: dashed;"
                    @dragover.prevent
                    @drop.prevent="onFileDrop"
                >
                    <img src="/icons/upload-icon.svg" alt="icono de flecha">
                    <h4 class="text-secondary">Arrastra tu archivo aquí o</h4>
                    <div class="file-select mb-3 cursor-pointer">
                        <input
                            type="file"
                            class="form-control rounder-8 form-input"
                            id="router_file"
                            name="router_file"
                            ref="router_file"
                            @change="showFileName"
                        >
                    </div>
                    <br>
                    <h4 v-if="name_file != ''" class="text-dark size-18"><strong>Archivo: </strong> {{ name_file }}</h4>
                    <div
                        v-if="errors.errors.router_file"
                        id="nameHelp"
                        class="form-text text-danger"
                    >
                        Es obligatorio subir un archivo con los datos.
                    </div>
                </form>
            </div>
        </div>
        <div class="mt-2">
            <span>
                <img src="/icons/excelxls-icon.svg" alt="icono de flecha" style="width: 16px;">
                <a :href="authentication_user.active_store ? `/static/model_file_config_reposition_cluster.xlsx` : '/static/model_file_config_reposition.xlsx'" target="_blank" class="text-dowload size-14">Descargar plantilla</a>
            </span>
        </div>
        <div class="mt-5 d-flex justify-content-end">
            <button
                class="btn bgc-success text-white px-4"
                @click="uploadFile"
            >
                Subir archivo
            </button>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name: "config-reposicion-file",
    computed: {
        ...mapGetters(["authentication_user"]),
    },
    data() {
        return {
            data: {
                router_file: null,
                client: null,
                business: null,
            },
            name_file: '',
            errors: {
                message: null,
                errors: {},
            },
        };
    },
    methods: {
        ...mapActions(["postWithFile", "executeCommit"]),
        uploadFile() {
            let formData = new FormData();
            this.data.router_file = this.$refs.router_file.files[0];
            this.data.business = this.authentication_user.client_business_select ? this.authentication_user.client_business_select : null;
            formData.append("router_file", this.data.router_file);
            formData.append("client", this.authentication_user.client);
            formData.append("type_file", 20);
            formData.append("business", this.data.business);

            this.postWithFile({
                url: `/api/products/update_config_replacement_cost_batch/`,
                formData: formData,
            }).then(() => {
                this.$notification.success("Datos actualizados correctamente.", {
                    timer: 10,
                    showCloseIcn: true,
                });
                this.close();
            }).catch((error) => {
                if (error.status == 400) {
                    this.errors = error.data;
                }
            });
        },
        showFileName(event) {
            this.name_file = event.target.files[0].name;
        },
        onFileDrop(event) {
            const files = event.dataTransfer.files;
            if (files.length > 0) {
                this.$refs.router_file.files = files;
                this.showFileName({ target: { files } });
            }
        },
        close() {
            this.executeCommit({
                mutation: "close_modal",
            });
            this.$emit("refrest");
        },
    },
};
</script>

<style scoped>
.text-secondary {
    font-size: 14px;
    color: #09090B !important;
}

.text-dowload {
    color: #09090B;
}

.bgc-success {
    background-color: #1AA179 !important;
}

.btn:hover {
    font-weight: 400;
}

.border-secondary {
    border-color: #D4D4D8 !important;
}
</style>
